import { render, staticRenderFns } from "./EnvironmentImportMetadataFast.vue?vue&type=template&id=9241f740&"
import script from "./EnvironmentImportMetadataFast.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentImportMetadataFast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports